import * as Sentry from '@sentry/browser';
import { userStore } from '@/shared/model/user';
export function handleSentryInfo(category, message, emailString) {
    const { id, email } = userStore.user;
    let messageWithUser = message;
    try {
        const parsed = JSON.parse(message);
        if (typeof parsed === 'object' && parsed !== null) {
            messageWithUser = JSON.stringify({ ...parsed, userId: id, email });
        }
    }
    catch {
        messageWithUser = `${message} |${id ? ` userId=${id},` : ''} email=${emailString || email}`;
    }
    Sentry.addBreadcrumb({
        category,
        message: messageWithUser,
        level: 'info',
    });
    const { logger } = Sentry;
    const attributes = { userId: id, email, category };
    logger.info(messageWithUser, attributes);
}
